import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import axios from 'axios';
import { Observable, Subject } from 'rxjs';
import { RbTags } from '../models/rb-tag';
import { RbCollection } from '../models/rb-collection';
import { Apollo, gql } from 'apollo-angular';
import { identifierName } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class StrapiApiService {
  apiUrl = environment.apiUrls.rbUrl;
  gqlUrl = environment.apiUrls.rbGqlUrl;

  constructor(private apollo: Apollo) { }

  getCount(url): Observable<any[]> {
    const subject = new Subject<any[]>();
    axios.get(`${this.apiUrl}/${url}/count`).then(response => {
      subject.next(response.data);
    }, (error) => {
      subject.next(error.error);
    });
    return subject.asObservable();
  }
  searchTags(key: any): Observable<RbCollection[]> {
    const subject = new Subject<RbCollection[]>();
    axios.get(`${this.apiUrl}/rb-tags/?name_contains=${key}`).then(response => {
      subject.next(response.data);
    }, (error) => {
      subject.next(error.error);
    });
    return subject.asObservable();
  }

  searchText(filter): Observable<RbCollection[]> {
    const subject = new Subject<RbCollection[]>();
    console.log( " <= filter => " + filter)
    axios.get(`${this.apiUrl}/rb-collections?${filter}`).then(response => {
      subject.next(response.data);
      console.log(response);
    }, (error) => {
      subject.next(error.error);
    });
    return subject.asObservable();
  }

  getTagsGraphql(): Observable<any[]> {
    const subject = new Subject<any[]>(); {
      this.apollo.query<any>({
        query: gql`
        query {
            rbTags{
              id
              name
              description
              rb_collections{
                id
              }
            }
          }
        `
      })
        .subscribe(({ data, loading }) => {
          subject.next(data.rbTags);
          // this.loading = loading;
        }
        );
      return subject.asObservable();
    }
  }
  getLmsV1(query?): Observable<any[]> {
    const subject = new Subject<any[]>(); {
      this.apollo.query<any>({
        query: gql`
          query {
            lmsV1s${query} {
                id
                title
                image{
                  url
                }
              }
            }
          `
      })
        .subscribe(({ data, loading }) => {
          subject.next(data.lmsV1s);
          // this.loading = loading;
        }
        );
      return subject.asObservable();
    }
  }
  getLmsV1ById(id): Observable<any[]> {
    const subject = new Subject<any[]>(); {
      this.apollo.query<any>({
        query: gql`
        query {
          lmsV1(id:${id}){
            id 
            title
            image{
              url
            }
            content1
            content2
            content3
            video1
            content4
            content5
            content6
            video2
            content7
            content8
            content9
            video3
            content10
            content11
            content12
            video4
            content13
            content14
            content15
            video5
            content16
            content17
            content18
            video6
            content19
            content20
            content21
            video7
            content22
            content23
            content24
            video8
            content25
            content26
            content27
            video9
            content28
            content29
            content30
            video10
          
        }
          }
        `
      })
        .subscribe(({ data, loading }) => {
          subject.next(data.lmsV1);
          // this.loading = loading;
        }
        );
      return subject.asObservable();
    }
  }

  getCollectionsbyId(id): Observable<any[]> {
    const subject = new Subject<any[]>(); {
      this.apollo.query<any>({
        query: gql`
        query {
          rbTag(id:${id}){
          rb_collections{
            id 
            title
            description
            rb_tags{
              name
              password_text
            }
          }
        }
          }
        `
      })
        .subscribe(({ data, loading }) => {
          subject.next(data.rbTag);
          // this.loading = loading;
        }
        );
      return subject.asObservable();
    }
  }

  getCollectionContent(id): Observable<any[]> {
    const subject = new Subject<any[]>(); {
      this.apollo.query<any>({
        query: gql`
        query {
          rbCollection(id:${id}){
            id 
            title
            description
            content_1
            content_2
            content_3
            content_4
            content_5
            rb_tags{
              id
              name
              password_text
          }
        }
          }
        `
      })
        .subscribe(({ data, loading }) => {
          subject.next(data.rbCollection);
          // this.loading = loading;
        }
        );
      return subject.asObservable();
    }
  }



}


